import { RouteConfig } from "vue-router";
import forexServices from './forex-services';
import localizationFactory from "@/router/modules/localization-factory";

export default {
	name: "",
	path: 'currency-operations',
	component: () => import('../views/Forex.vue'),
	meta: {
		layout: 'main',
		className: "header-sm-none"
	},
	children: [
		{
			path: "/",
			name: "",
			meta: localizationFactory('forex.title', {
				layout: "main",
				className: "header-sm-none"
			}),
			component: () => import('../views/ForexService.vue'),
			children: forexServices
		}
	]
} as RouteConfig;